import { boot } from '@dazn/bootstrap-lib';

export const handleCommonFeEvent: boot.feEvents.FeEventHandler = (
    payload,
    meta,
) => {
    if (meta.gtm) {
        pushToGTM({
            ...payload,
            event: meta.name,
        });
    }
};

export interface GTMEvent {
    event: string;
}
export const pushToGTM = (event: GTMEvent) => {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    window.dataLayer.push(event);
};
